"use client";

import { useEffect, useRef } from "react";
import { useLocale } from "next-intl";

import type { PagebuilderType } from "@/lib/types";
import { getI18nString } from "@/lib/utils";

const COOKIEBOT_CBID =
  process.env.NEXT_PUBLIC_COOKIEBOT_CBID ??
  "f8a68aaa-bcd1-422c-8b36-c07632a15bd3";

type CookieDeclarationBlockProps = PagebuilderType<"cookieDeclaration">;

export function CookieDeclarationBlock({
  heading,
}: CookieDeclarationBlockProps): JSX.Element {
  const locale = useLocale();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || container.querySelector("#CookieDeclaration")) return;

    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = `https://consent.cookiebot.com/${COOKIEBOT_CBID}/cd.js`;
    script.async = true;
    container.appendChild(script);
  }, []);

  const headingText = getI18nString(heading, "", locale);

  return (
    <section className="my-16 px-4">
      <div className="mx-auto max-w-7xl">
        {headingText && (
          <h2 className="typography-desktop-heading-h3-voyage mb-10">
            {headingText}
          </h2>
        )}
        <div ref={containerRef} />
      </div>
    </section>
  );
}
